import { createRoot } from 'react-dom/client';
import './redirectFromOldDomains';
import React from 'react';
import App from './App';

const container = document.getElementById('root');
const root = container && createRoot(container);

root?.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
